import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { gql } from "graphql-tag";

const CHECK_MOBILE = gql`
  query ($mobile: String!, $link: String!) {
    checkMobile(mobile: $mobile, link: $link)
  }
`;

const useCheckMobile = (mobile, link) => {
  const [checkMobile, setcheckMobile] = useState("");
  const [debouncedMobile, setDebouncedMobile] = useState(mobile);

  // Debounce logic
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedMobile(mobile);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [mobile]);

  // Use GraphQL query to check mobile
  const { data, loading, error } = useQuery(CHECK_MOBILE, {
    variables: { mobile: debouncedMobile, link },
    skip: !debouncedMobile || !link, // Skip query if mobile or link is empty
    fetchPolicy: "no-cache", // Prevent caching
  });
  console.log(data?.checkMobile, ">>>>");

  useEffect(() => {
    if (loading) {
      setcheckMobile("Checking mobile...");
    } else if (error) {
      console.error(error);
      setcheckMobile("Error checking mobile.");
    } else if (data?.checkMobile) {
      setcheckMobile(data?.checkMobile);
    } else {
      setcheckMobile(""); // Clear error if mobile is valid
    }
  }, [loading, error, data]);

  return { checkMobile, loading };
};

export default useCheckMobile;
